<section class="container-fluid bg-white" *ngIf="documents_list && documents_list.length > 0">
  <!--- header -->
  <header class="row">
    <div class="col-xl-3 col-12 d-flex align-items-center" [ngClass.sm]="'pt-1'" [ngClass.md]="'pt-1'">
      <img src="../assets/images/logo/nepta.svg" alt="brand-logo" height="28" />
    </div>
    <div class="col-xl-9 col-12 px-xl-0">
      <app-onboarding-header></app-onboarding-header>
    </div>
  </header>
  <!--- body -->
  <div class="row" id="main-container">
    <div class="col-md-9 col-12 offset-md-3 pt-2 position-relative">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-12">
          <h1>{{ "DOCUMENTS" | translate }}</h1>
          <small>{{ "INSERT.VIEW_ONBOARDING_DOCUMENT" | translate }}</small>
        </div>
        <div class="col-lg-6 col-md-6 col-12 text-lg-right text-md-right text-left">
          <span (click)="showVideo()" [ngbTooltip]="'SHOW_TUTORIAL' | translate" placement="top" class="cursor-pointer text-primary">{{ "DONT_KNOW_HOW_TO_DO" | translate }}</span>
        </div>
      </div>
      <div class="row align-items-center py-2 pr-md-2 border-bottom" [ngClass.sm]="'flex-column'" *ngFor="let document of documents_list">
        <div class="col-md-10 col-12">
          <span class="mr-1">{{ document.title }}</span>
        </div>
        <div class="col-md-2 col-12 text-center" [ngClass.sm]="'mt-1'">
          <button *ngIf="!documentViewed.includes(document.id)" class="btn btn-outline-danger btn-sm" (click)="viewDocument(document.id); _utilService.getFile(document.url)">{{ "VIEW" | translate }}</button>
          <div (click)="_utilService.getFile(document.url)" *ngIf="documentViewed.includes(document.id)" [ngbTooltip]="'VIEW_DOCUMENT' | translate" class="w-fit mx-auto">
            <span class="text-success cursor-pointer" [data-feather]="'check'" [size]="'25'"></span>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="form-group col-12">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="checkAllDocument" [(ngModel)]="acceptViewAllDocuments" />
            <label class="custom-control-label" for="checkAllDocument">{{ "ACKNOWlLEDGMENT_DICHIARATION" | translate }}</label>
          </div>
        </div>
      </div>
      <div class="row pr-md-2 pt-2">
        <div class="col-12 d-flex justify-content-end mb-4">
          <button (click)="save()" type="submit" class="btn btn-primary" [disabled]="!acceptViewAllDocuments || documentViewed.length !== documents_list.length">{{ "NEXT" | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</section>
